import type { Callback } from 'ts/base/Callback';
import { BranchComboBox } from 'ts/commons/branch-options/BranchComboBox';
import { HelpIcon } from 'ts/commons/components/HelpIcon';
import { PointInTimeInput } from 'ts/commons/components/PointInTimeInput';
import { TimeUtils } from 'ts/commons/time/TimeUtils';
import { FormField } from 'ts/components/Form';

type CommitAndBranchChooserProps = {
	branchSelectorLabel: string;
	datePickerLabel: string;
	datePickerTooltip?: string;
	projects: string[];
	timestamp: number | null;
	branchName: string | null;
	onTimestampChange: Callback<number | null>;
	onBranchNameChange: Callback<string>;
};

/** Combined date and branch chooser also syncs the branch between both components when selecting a revision. */
export function DateAndBranchChooser({
	branchSelectorLabel,
	datePickerLabel,
	datePickerTooltip,
	projects,
	timestamp,
	branchName,
	onTimestampChange,
	onBranchNameChange
}: CommitAndBranchChooserProps) {
	let datePickerTooltipElement = null;
	if (datePickerTooltip) {
		datePickerTooltipElement = <HelpIcon textOrMarkdown={datePickerTooltip} />;
	}
	const dateId = datePickerLabel.toLowerCase().replace(' ', '-');
	const branchId = `${branchSelectorLabel.toLowerCase().replace(' ', '-')}-selector`;

	return (
		<>
			<FormField id="date-time-field">
				<label htmlFor={dateId}>
					{datePickerLabel} {datePickerTooltipElement}
				</label>
				<PointInTimeInput
					inputId={dateId}
					projects={projects}
					initialValue={timestamp != null ? TimeUtils.timestamp(timestamp) : TimeUtils.now()}
					onCommitChanged={commit => {
						onTimestampChange(commit.timestamp);
						if (commit.branchName != null) {
							onBranchNameChange(commit.branchName);
						}
					}}
				/>
			</FormField>
			<FormField>
				<label htmlFor={branchId}>{branchSelectorLabel}</label>
				<BranchComboBox
					key={branchName}
					id={branchId}
					value={branchName}
					projectIds={projects}
					onChange={onBranchNameChange}
				/>
			</FormField>
		</>
	);
}
